module.exports = __webpack_public_path__ + "static/media/layout-8.f7878794.svg";